import { useLocation, useNavigate } from "react-router-dom";
import MDBox from "../../components/MDBox";
import { Card, Grid } from "@mui/material";
import MDButton from "../../components/MDButton";
import { DataGrid } from "@mui/x-data-grid";
import * as React from "react";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import { useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import Loading from "../../components/Loading";
import separate from "../../components/seperate";

export default function ReservationPrintPreview() {
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const componentRef = useRef();
  const { info } = state ?? [];
  const navigate = useNavigate();
  const tablePrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);


  const handlePrint = useReactToPrint({
    content: tablePrintContent,
    onBeforePrint: () => setLoading(true),
    onAfterPrint: () => setLoading(false),
    removeAfterPrint: true,
    pageStyle: "@page {size: A4 landscape;margin: 0;}",
  });

  const columns = [
      {
        field: "index", headerName: "ردیف", width: 80,
      },
      {
        field: "firstName",
        headerName: "نام و نام خانوادگی",
        width: 200,
        valueGetter: (params) => `${params.row.firstName} ${params.row.lastName}`,

      },
      {
        field: "nationalCode",
        headerName: "کدملی",
        width: 120,
      },
      {
        field: "groupName",
        headerName: "تخصص نوبت",
        width: 250,
      },
      {
        field: "reservationDate",
        headerName: "تاریخ نوبت",
        width: 160,
        valueGetter: (params) => `${params.row.reservationTime} - ${String(params.row.reservationDate).slice(0, 4)}/${String(params.row.reservationDate).slice(4, 6)}/${String(params.row.reservationDate).slice(6)}`,
      },
      {
        field: "admissionDate",
        headerName: "تاریخ پذیرش",
        width: 120,
        render: (params) => <p
          style={{ direction: "ltr !important", wordBreak: "break-all" }}>{params.row.admissionDate}</p>,
      },
      {
        field: "admissionUser",
        headerName: "کاربر پذیرش",
        width: 120,
      },
      {
        field: "insuranceRefCode",
        headerName: "کدپیگیری بیمه",
        width: 120,
      },
      {
        field: "transactionPrice",
        headerName: "مبلغ پرداخت",
        width: 120,
        valueGetter: (params) => `${separate(params.row.transactionPrice)} تومان`,

      },
      {
        field: "transactionRefId",
        headerName: "ارجاع بانک",
        width: 120,
      },

    ]
  ;

  return (
    <DashboardLayout>
      <Loading loading={loading} />
      <MDBox pt={2} mb={6}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox pt={2} px={2}>
                <div style={{ marginBottom: 8 }}>
                  <MDButton onClick={handlePrint} variant="gradient" color="info"
                            sx={{ width: "140px", marginRight: 2 }}>
                    چاپ گزارش
                  </MDButton>
                  <MDButton onClick={() => navigate(-1)} variant="gradient" color="light"
                            sx={{ width: "140px", marginRight: 2 }}>
                    بازگشت
                  </MDButton>
                </div>
                <div id="scrollableDiv">
                  <DataGrid
                    rows={info.map((item, index) => ({ index: index + 1, ...item }))}
                    ref={componentRef}
                    columns={columns}
                    hideFooter
                    getRowId={(item) => item.patientId}
                    rowSelection={false}
                  />
                </div>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}
